<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
   <circle fill="none" cx="12" cy="12" r="10.5" stroke="currentColor" stroke-width="1"></circle>
   <rect fill="currentColor" x="9" y="8" width="2" height="8" rx="1"></rect>
   <rect fill="currentColor" x="13" y="8" width="2" height="8" rx="1"></rect>
</svg>
